import React from "react";
import ItemsPage from "./ItemsTab";
import CategoriesPage from "./Categories";
import OrdersPage from "./OrdersTab";
import SoldoutPage from "./Soldout";
// import CompletedOrders from "./CompletedOrdersTab";
import BuffetBookings from "./BuffetBookings";
import HallRentals from "./HallRentals";
import DettyDecember from "./DettyDecember";
import Customers from "./CustomersTab";
import Analytics from "./Analytics";

const handleDragOver = (e) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = "move";
};

const MainContent = ({ activeTab, setIsAnyModalActive, isAnyModalActive }) => {
  return (
    <div className="main-content" onDragOver={(e) => handleDragOver(e)}>
      {activeTab === "categories" && (
        <CategoriesPage setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "items" && (
        <ItemsPage setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "outofstock" && (
        <SoldoutPage setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "orders" && (
        <OrdersPage
          setIsAnyModalActive={setIsAnyModalActive}
          isAnyModalActive={isAnyModalActive}
        />
      )}
      {/* {activeTab === "completed-orders" && (
        <CompletedOrders setIsAnyModalActive={setIsAnyModalActive} />
      )} */}
      {activeTab === "buffet-bookings" && (
        <BuffetBookings setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "hall-rentals" && (
        <HallRentals setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "detty-december" && (
        <DettyDecember setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "customers" && (
        <Customers setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "analytics" && (
        <Analytics setIsAnyModalActive={setIsAnyModalActive} />
      )}
    </div>
  );
};

export default MainContent;
